// extracted by mini-css-extract-plugin
export default {"content":"AboutPage_content__xAcYI","section":"AboutPage_section__yglJa","wrapper":"AboutPage_wrapper__chwvA","title":"AboutPage_title__98JT-"};